import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Inscripcion from "../../models/Inscripcion";
import Representante from "../../models/Representante";
import { sexo, listJornada, listSiNo } from "../../utils/opciones.js";
import { navigate } from '@reach/router';
import { useStore } from "../../context";
import Pagador from '../../models/Pagador';
import { verificarCedula, verificarRuc, verificarPasaporte, soloNumeros, soloAlfanumerico, toMayusculas } from '../../utils';
import Swal from 'sweetalert2';
import "../../styles/theme.css";
import logoanai from "../../images/logos/logoanai.png";

var moment = require('moment');

/* ───────── inline styles ───────── */
const stepBarStyle = {
  display: 'flex', justifyContent: 'center', gap: 0, margin: '0 auto 28px', maxWidth: 700
};
const stepItemStyle = (active, done) => ({
  flex: 1, textAlign: 'center', padding: '12px 6px', fontWeight: 700, fontSize: '.85rem',
  color: active ? '#fff' : done ? '#0d1b3e' : '#999',
  background: active ? 'linear-gradient(135deg,#0d1b3e,#1a3a7a)' : done ? '#e8eaf6' : '#f5f5f5',
  borderBottom: active ? '3px solid #d4a017' : '3px solid transparent',
  cursor: 'pointer', transition: 'all .3s',
  borderRadius: 0,
});
const sectionStyle = { marginBottom: 22 };
const labelStyle = { fontWeight: 700, color: '#0d1b3e', marginBottom: 6, display: 'block', fontSize: '.93rem' };
const inputStyle = {
  width: '100%', padding: '10px 14px', border: '1.5px solid #cfd8dc', borderRadius: 8,
  fontSize: '.95rem', outline: 'none', transition: 'border .25s', background: '#fff',
};
const inputErrorStyle = { ...inputStyle, border: '1.5px solid #e53935' };
const selectStyle = { ...inputStyle, appearance: 'auto' };
const rowStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 };
const pillContainerStyle = { display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 };
const pillStyle = (active) => ({
  padding: '7px 18px', borderRadius: 20, cursor: 'pointer', fontWeight: 600, fontSize: '.88rem',
  border: active ? '2px solid #0d1b3e' : '2px solid #cfd8dc',
  background: active ? '#0d1b3e' : '#fff',
  color: active ? '#fff' : '#555',
  transition: 'all .25s',
});
const btnRow = { display: 'flex', justifyContent: 'center', gap: 14, marginTop: 28, flexWrap: 'wrap' };

export default function Inscripciones() {
  const { state, dispatch } = useStore();
  const [paso, setSteps] = React.useState(0);

  /* ── Student fields ── */
  const [tipDoc, setTipDoc] = React.useState('C');
  const [cedulaE, setCedulaE] = React.useState({ textmask: '', numberformat: '1320' });
  const [errorCedulaE, setErrorCedulaE] = React.useState(false);
  const refCedulaE = React.useRef();
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [nombresA, setNombresE] = React.useState('');
  const [apellidosA, setApelE] = React.useState('');
  const [sex, setSex] = React.useState('M');
  const [jornada, setJornada] = React.useState('M');
  const [grado, setGrado] = React.useState(sessionStorage.getItem("grados") ? sessionStorage.getItem("grados")[0].value : 'Default');
  const [estudio, setEstudio] = React.useState('S');
  const [institucionAntes, setInstitucion] = React.useState('');
  const [personasVive, setPersonas] = React.useState('');
  const [hijoEx, setHijoEx] = React.useState('S');
  const [state2, setState2] = React.useState({ checkedA: false });

  /* ── Parent fields ── */
  const [tipDocP, setTipoDocP] = React.useState('C');
  const [cedulap, setCedulaP] = React.useState({ textmask: '', numberformat: '1320' });
  const [errorCedulaP, setErrorCedulaP] = React.useState(false);
  const refCedulaP = React.useRef();
  const [nombresP, setNombresP] = React.useState('');
  const [apellidosP, setApellidosP] = React.useState('');
  const [tipDocM, setTipoDocM] = React.useState('C');
  const [cedulaM, setCedulaM] = React.useState({ textmask: '', numberformat: '1320' });
  const [errorCedulaM, setErrorCedulaM] = React.useState(false);
  const refCedulaM = React.useRef();
  const [nombresM, setNombresM] = React.useState('');
  const [apellidosM, setApellidosM] = React.useState('');
  const [mail, setMail] = React.useState('');
  const [mailM, setMail2] = React.useState('');
  const [celular, setCelular] = React.useState('');
  const [convencional, setConvencional] = React.useState('');

  /* ── Payer fields ── */
  const [tipoDocPag, setValueTip] = React.useState('CI');
  const [cedulaPa, setCedulaPa] = React.useState({ textmask: '', numberformat: '1320' });
  const [errorCedulaPa, setErrorCedulaPa] = React.useState(false);
  const refCedulaPa = React.useRef();
  const [nombresPa, setNombresPa] = React.useState('');
  const [apellidosPa, setApelPa] = React.useState('');
  const [mailPa, setMailPa] = React.useState('');
  const [direccionPa, setDireccionPa] = React.useState('');

  /* ── Error messages state ── */
  const [errorMsg, setErrorMsg] = React.useState({
    cedulaE: '', nombresA: '', apellidosA: '',
    cedulaP: '', nombresP: '', apellidosP: '',
    cedulaM: '', nombresM: '', apellidosM: '',
    mail: '', mailM: '', celular: '', convencional: '',
    cedulaPa: '', nombresPa: '', apellidosPa: '', mailPa: '', direccionPa: ''
  });
  const errorMsgStyle = { color: '#e53935', fontSize: '0.8rem', marginTop: 4, display: 'block' };

  /* ── Generic onChange helpers ── */
  const changeCedE = e => {
    const value = tipDoc === 'P' ? soloAlfanumerico(e.target.value) : soloNumeros(e.target.value);
    setCedulaE({ ...cedulaE, [e.target.name]: value });
  };
  const changeCedP = e => {
    const value = tipDocP === 'P' ? soloAlfanumerico(e.target.value) : soloNumeros(e.target.value);
    setCedulaP({ ...cedulap, [e.target.name]: value });
  };
  const changeCedM = e => {
    const value = tipDocM === 'P' ? soloAlfanumerico(e.target.value) : soloNumeros(e.target.value);
    setCedulaM({ ...cedulaM, [e.target.name]: value });
  };
  const changeCedPa = e => {
    const value = tipoDocPag === 'PPN' ? soloAlfanumerico(e.target.value) : soloNumeros(e.target.value);
    setCedulaPa({ ...cedulaPa, [e.target.name]: value });
  };

  /* ── Swal helper ── */
  const showWarn = (msg) => Swal.fire({ icon: 'warning', title: 'Atención', text: msg, confirmButtonColor: '#0d1b3e' });

  /* ────────────── VALIDATION ────────────── */
  const blurCedulaE = () => {
    const v = cedulaE.textmask.trim();
    if (v === '') { setErrorCedulaE(true); setErrorMsg(p => ({...p, cedulaE: 'Campo requerido'})); return; }
    if (tipDoc === 'C') {
      if (v.length !== 10) { setErrorCedulaE(true); setErrorMsg(p => ({...p, cedulaE: 'La cédula debe tener 10 dígitos'})); return; }
      if (!verificarCedula(v)) { setErrorCedulaE(true); setErrorMsg(p => ({...p, cedulaE: 'Cédula inválida'})); return; }
    } else if (tipDoc === 'P') {
      if (!verificarPasaporte(v)) { setErrorCedulaE(true); setErrorMsg(p => ({...p, cedulaE: 'Pasaporte inválido (5-13 caracteres)'})); return; }
    }
    setErrorCedulaE(false); setErrorMsg(p => ({...p, cedulaE: ''}));
  };
  const blurCedulaP = () => {
    const v = cedulap.textmask.trim();
    if (v === '') { setErrorCedulaP(true); setErrorMsg(p => ({...p, cedulaP: 'Campo requerido'})); return; }
    if (tipDocP === 'C') {
      if (v.length !== 10) { setErrorCedulaP(true); setErrorMsg(p => ({...p, cedulaP: 'La cédula debe tener 10 dígitos'})); return; }
      if (!verificarCedula(v)) { setErrorCedulaP(true); setErrorMsg(p => ({...p, cedulaP: 'Cédula inválida'})); return; }
    } else if (tipDocP === 'R') {
      if (v.length !== 13) { setErrorCedulaP(true); setErrorMsg(p => ({...p, cedulaP: 'El RUC debe tener 13 dígitos'})); return; }
      if (!verificarRuc(v)) { setErrorCedulaP(true); setErrorMsg(p => ({...p, cedulaP: 'RUC inválido'})); return; }
    } else if (tipDocP === 'P') {
      if (!verificarPasaporte(v)) { setErrorCedulaP(true); setErrorMsg(p => ({...p, cedulaP: 'Pasaporte inválido (5-13 caracteres)'})); return; }
    }
    setErrorCedulaP(false); setErrorMsg(p => ({...p, cedulaP: ''}));
  };
  const blurCedulaM = () => {
    const v = cedulaM.textmask.trim();
    if (v === '') { setErrorCedulaM(true); setErrorMsg(p => ({...p, cedulaM: 'Campo requerido'})); return; }
    if (tipDocM === 'C') {
      if (v.length !== 10) { setErrorCedulaM(true); setErrorMsg(p => ({...p, cedulaM: 'La cédula debe tener 10 dígitos'})); return; }
      if (!verificarCedula(v)) { setErrorCedulaM(true); setErrorMsg(p => ({...p, cedulaM: 'Cédula inválida'})); setErrorMsg(p => ({...p, cedulaM: 'Cédula inválida'})); return; }
    } else if (tipDocM === 'R') {
      if (v.length !== 13) { setErrorCedulaM(true); setErrorMsg(p => ({...p, cedulaM: 'El RUC debe tener 13 dígitos'})); return; }
      if (!verificarRuc(v)) { setErrorCedulaM(true); setErrorMsg(p => ({...p, cedulaM: 'RUC inválido'})); return; }
    } else if (tipDocM === 'P') {
      if (!verificarPasaporte(v)) { setErrorCedulaM(true); setErrorMsg(p => ({...p, cedulaM: 'Pasaporte inválido (5-13 caracteres)'})); return; }
    }
    setErrorCedulaM(false); setErrorMsg(p => ({...p, cedulaM: ''}));
  };
  const blurCedulaPa = () => {
    const v = cedulaPa.textmask.trim();
    if (v === '') { setErrorCedulaPa(true); setErrorMsg(p => ({...p, cedulaPa: 'Campo requerido'})); return; }
    if (tipoDocPag === 'CI') {
      if (v.length !== 10) { setErrorCedulaPa(true); setErrorMsg(p => ({...p, cedulaPa: 'La cédula debe tener 10 dígitos'})); return; }
      if (!verificarCedula(v)) { setErrorCedulaPa(true); setErrorMsg(p => ({...p, cedulaPa: 'Cédula inválida'})); return; }
    } else if (tipoDocPag === 'RUC') {
      if (v.length !== 13) { setErrorCedulaPa(true); setErrorMsg(p => ({...p, cedulaPa: 'El RUC debe tener 13 dígitos'})); return; }
      if (!verificarRuc(v)) { setErrorCedulaPa(true); setErrorMsg(p => ({...p, cedulaPa: 'RUC inválido'})); return; }
    } else if (tipoDocPag === 'PPN') {
      if (!verificarPasaporte(v)) { setErrorCedulaPa(true); setErrorMsg(p => ({...p, cedulaPa: 'Pasaporte inválido (5-13 caracteres)'})); return; }
    }
    setErrorCedulaPa(false); setErrorMsg(p => ({...p, cedulaPa: ''}));
  };
  /* Blur validators for text fields */
  const blurField = (field, value, label) => {
    if (value.trim() === '') { setErrorMsg(p => ({...p, [field]: `${label} es requerido`})); return true; }
    setErrorMsg(p => ({...p, [field]: ''})); return false;
  };
  const blurEmail = (field, value) => {
    if (value.trim() === '') { setErrorMsg(p => ({...p, [field]: 'Correo requerido'})); return true; }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) { setErrorMsg(p => ({...p, [field]: 'Formato de correo inválido'})); return true; }
    setErrorMsg(p => ({...p, [field]: ''})); return false;
  };
  const blurPhone = (field, value, label) => {
    if (value.trim() === '') { setErrorMsg(p => ({...p, [field]: `${label} es requerido`})); return true; }
    if (value.length < 9 || !/^\d+$/.test(value)) { setErrorMsg(p => ({...p, [field]: 'Número inválido (mínimo 9 dígitos)'})); return true; }
    setErrorMsg(p => ({...p, [field]: ''})); return false;
  };
  /* ────────────── STEP VALIDATION ────────────── */
  const validarPaso1 = () => {
    let hasError = false;
    
    // Validate identification
    if (cedulaE.textmask.trim() === '') {
      setErrorCedulaE(true);
      setErrorMsg(p => ({...p, cedulaE: 'Campo requerido'}));
      hasError = true;
    } else if (tipDoc === 'C' && cedulaE.textmask.length !== 10) {
      setErrorCedulaE(true);
      setErrorMsg(p => ({...p, cedulaE: 'La cédula debe tener 10 dígitos'}));
      hasError = true;
    } else if (tipDoc === 'C' && !verificarCedula(cedulaE.textmask)) {
      setErrorCedulaE(true);
      setErrorMsg(p => ({...p, cedulaE: 'Cédula inválida'}));
      hasError = true;
    } else if (tipDoc === 'P' && !verificarPasaporte(cedulaE.textmask)) {
      setErrorCedulaE(true);
      setErrorMsg(p => ({...p, cedulaE: 'Pasaporte inválido'}));
      hasError = true;
    }
    
    // Validate names
    if (nombresA.trim() === '') {
      setErrorMsg(p => ({...p, nombresA: 'Nombres es requerido'}));
      hasError = true;
    }
    if (apellidosA.trim() === '') {
      setErrorMsg(p => ({...p, apellidosA: 'Apellidos es requerido'}));
      hasError = true;
    }
    
    // Validate other required fields
    if (selectedDate === null) {
      showWarn('Debe seleccionar una fecha de nacimiento.');
      return false;
    }
    if (personasVive.trim() === '') {
      showWarn('Debe indicar personas con las que vive el estudiante.');
      return false;
    }
    if (state2.checkedA === false) {
      showWarn('Debe confirmar que el aspirante tiene calificación A o B.');
      return false;
    }
    
    if (hasError) {
      showWarn('Por favor complete los campos requeridos correctamente.');
      return false;
    }
    
    return true;
  };

  const validarPaso2 = () => {
    let hasError = false;
    
    // Validate father ID
    if (cedulap.textmask.trim() === '') {
      setErrorCedulaP(true);
      setErrorMsg(p => ({...p, cedulaP: 'Campo requerido'}));
      hasError = true;
    }
    // Validate father names
    if (nombresP.trim() === '') {
      setErrorMsg(p => ({...p, nombresP: 'Nombres es requerido'}));
      hasError = true;
    }
    if (apellidosP.trim() === '') {
      setErrorMsg(p => ({...p, apellidosP: 'Apellidos es requerido'}));
      hasError = true;
    }
    
    // Validate mother ID
    if (cedulaM.textmask.trim() === '') {
      setErrorCedulaM(true);
      setErrorMsg(p => ({...p, cedulaM: 'Campo requerido'}));
      hasError = true;
    }
    // Validate mother names
    if (nombresM.trim() === '') {
      setErrorMsg(p => ({...p, nombresM: 'Nombres es requerido'}));
      hasError = true;
    }
    if (apellidosM.trim() === '') {
      setErrorMsg(p => ({...p, apellidosM: 'Apellidos es requerido'}));
      hasError = true;
    }
    
    // Validate emails
    const emailRegex = /^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/;
    if (mail.trim() === '' || !emailRegex.test(mail)) {
      setErrorMsg(p => ({...p, mail: 'Correo del padre inválido'}));
      hasError = true;
    }
    if (mailM.trim() === '' || !emailRegex.test(mailM)) {
      setErrorMsg(p => ({...p, mailM: 'Correo de la madre inválido'}));
      hasError = true;
    }
    
    // Validate phones
    if (celular.trim() === '' || celular.length < 9) {
      setErrorMsg(p => ({...p, celular: 'Celular requerido (mín 9 dígitos)'}));
      hasError = true;
    }
    if (convencional.trim() === '' || convencional.length < 7) {
      setErrorMsg(p => ({...p, convencional: 'Teléfono requerido'}));
      hasError = true;
    }
    
    // Check father != mother
    if (cedulap.textmask === cedulaM.textmask && cedulap.textmask !== '') {
      showWarn('Las cédulas de padre y madre deben ser diferentes.');
      return false;
    }
    
    if (hasError) {
      showWarn('Por favor complete los campos requeridos correctamente.');
      return false;
    }
    
    return true;
  };

  const siguientePaso = (pasoActual) => {
    if (pasoActual === 0 && validarPaso1()) {
      setSteps(1);
    } else if (pasoActual === 1 && validarPaso2()) {
      setSteps(2);
    }
  };
  /* ────────────── SUBMIT ────────────── */
  const validarData = async () => {
    try {
      let validate = false;
      let usuario = sessionStorage.getItem("username");
      let _hoy = moment();
      _hoy = _hoy.format("YYYY-MM-DD HH:mm:ss");
      let hoy = new Date(_hoy);

      if (cedulaE.textmask === "") return showWarn('Debe ingresar el número de identificación del aspirante.');
      if (nombresA === "") return showWarn('Debe ingresar los nombres del aspirante.');
      if (apellidosA === "") return showWarn('Debe ingresar los apellidos del aspirante.');
      if (estudio === "N" && institucionAntes === "") return showWarn('Debe indicar su institución anterior.');
      if (selectedDate === null) return showWarn('Debe seleccionar una fecha.');
      if (personasVive === "") return showWarn('Debe ingresar a las personas con quién vive.');
      if (state2.checkedA === false) return showWarn('Debe indicar si aspirante tiene calificación A o B.');
      if (cedulap.textmask === "") return showWarn('Debe ingresar el número de identificación del Padre.');
      if (cedulaM.textmask === "") return showWarn('Debe ingresar el número de identificación de la madre.');
      if (nombresM === "") return showWarn('Debe ingresar los nombres de la madre.');
      if (apellidosM === "") return showWarn('Debe ingresar los apellidos de la madre.');
      if (nombresP === "") return showWarn('Debe ingresar los nombres del padre.');
      if (apellidosP === "") return showWarn('Debe ingresar los apellidos del padre.');
      if (mail === "") return showWarn('Debe ingresar el correo electrónico del padre.');
      if (mailM === "") return showWarn('Debe ingresar el correo electrónico de la madre.');
      if (celular === "") return showWarn('Debe ingresar un número de celular.');
      if (convencional === "") return showWarn('Debe ingresar un número convencional.');
      if (cedulaPa.textmask === "") return showWarn('Debe ingresar el número de identificación de quién realizará el pago.');
      if (nombresPa === "") return showWarn('Debe ingresar los nombres de quién realizará el pago.');
      if (apellidosPa === "") return showWarn('Debe ingresar los apellidos de quién realizará el pago.');
      if (mailPa === "") return showWarn('Debe ingresar el correo electrónico de la persona que realizará el pago.');
      if (direccionPa === "") return showWarn('Debe ingresar la dirección de la persona que realizará el pago.');
      if (cedulaE.textmask.length > 10) return showWarn('Número de dígitos en la identificación del aspirante mayor a 10.');
      if (cedulaPa.textmask.length > 10) return showWarn('Número de dígitos en la identificación del pagador mayor a 10.');
      if (cedulaM.textmask.length > 10) return showWarn('Número de dígitos en la identificación de la madre mayor a 10.');
      if (cedulap.textmask.length > 10) return showWarn('Número de dígitos en la identificación del padre mayor a 10.');
      if (cedulap.textmask === cedulaM.textmask) return showWarn('Cédulas de Padre y Madre deben ser distintas.');

      let arrayRepresentantes = [];
      let objPago = new Pagador(tipoDocPag, cedulaPa.textmask, nombresPa, apellidosPa, mailPa, "", direccionPa);
      let objRepresentante = new Representante(null, tipDocP, cedulap.textmask, nombresP.toUpperCase(), apellidosP.toUpperCase(), mail, celular, convencional, usuario, hoy, null, null, "A", "P");
      let objRepresentante2 = new Representante(null, tipDocM, cedulaM.textmask, nombresM.toUpperCase(), apellidosM.toUpperCase(), mailM, celular, convencional, usuario, hoy, null, null, "A", "M");
      arrayRepresentantes.push(objRepresentante);
      arrayRepresentantes.push(objRepresentante2);

      let objInscripcion = new Inscripcion(null, tipDoc, cedulaE.textmask, nombresA, apellidosA, selectedDate, sex, jornada, grado, estudio, institucionAntes, personasVive, hijoEx, state2.checkedA && "S", null, usuario, hoy, null, null, 'A', state.opciones.tasaInscripcion, arrayRepresentantes, null, "N", state.opciones.periodoinscripcion, "", "");

      state.cartIns.forEach((item) => {
        if (item.numDoc === objInscripcion.numDoc) validate = true;
      });

      if (!validate) {
        dispatch({ type: "ADD_CART_INS", payload: objInscripcion });
        dispatch({ type: "ADD_PAGADOR", payload: objPago });
        Swal.fire({ icon: 'success', title: '¡Agregado!', text: 'Se ha añadido a su carrito nuevo items.', confirmButtonColor: '#0d1b3e' });
      } else {
        showWarn('Ya existe registrado un aspirante con ese número de identificación.');
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Error al agregar inscripción.', confirmButtonColor: '#0d1b3e' });
    }
  };

  /* ── Doc-type label helper ── */
  const docLabel = (type) => {
    if (type === 'R' || type === 'RUC') return 'Número de RUC';
    if (type === 'P' || type === 'PPN') return 'Número de pasaporte';
    return 'Número de identificación';
  };

  const stepLabels = ['1. Información del Estudiante', '2. Información Adicional', '3. Datos del Pagador'];

  /* ════════════════════ RENDER ════════════════════ */
  return (
    <div className="login-bg" style={{ minHeight: '100vh', alignItems: 'flex-start', paddingTop: 30, paddingBottom: 40 }}>
      <div style={{ width: '100%', maxWidth: 780, margin: '0 auto', padding: '0 16px' }}>

        {/* ─── Header ─── */}
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <img src={logoanai} alt="ANAI" style={{ width: 70, marginBottom: 6 }} />
          <h2 style={{ color: '#fff', margin: 0, fontSize: '1.4rem', textShadow: '0 1px 4px rgba(0,0,0,0.3)' }}>Formulario de Inscripción</h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '.88rem', marginTop: 4 }}>Complete los tres pasos para agregar la inscripción al carrito.</p>
        </div>

        {/* ─── Step bar ─── */}
        <div style={stepBarStyle}>
          {stepLabels.map((lbl, i) => (
            <div key={i} style={stepItemStyle(paso === i, i < paso)} onClick={() => setSteps(i)}>
              {lbl}
            </div>
          ))}
        </div>

        {/* ─── Card ─── */}
        <div className="modern-card" style={{ padding: '28px 32px', borderRadius: 14 }}>

          {/* ═══════ PASO 1 ═══════ */}
          {paso === 0 && (
            <div>
              <p style={{ color: '#555', marginBottom: 20, fontSize: '.9rem' }}>
                Ingrese los datos del alumno. Los campos con <b>(*)</b> son obligatorios.
              </p>

              {/* Doc type */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Documento de identidad del aspirante (*)</span>
                <div style={pillContainerStyle}>
                  {[{ v: 'C', l: 'Cédula' }, { v: 'P', l: 'Pasaporte' }].map(o => (
                    <span key={o.v} style={pillStyle(tipDoc === o.v)} onClick={() => setTipDoc(o.v)}>{o.l}</span>
                  ))}
                </div>
              </div>

              {/* ID field */}
              <div style={sectionStyle}>
                <span style={labelStyle}>{docLabel(tipDoc)} (*)</span>
                <input
                  ref={refCedulaE}
                  name="textmask"
                  value={cedulaE.textmask}
                  onChange={(e) => { changeCedE(e); setErrorMsg(p => ({...p, cedulaE: ''})); setErrorCedulaE(false); }}
                  onBlur={blurCedulaE}
                  maxLength={tipDoc === 'P' ? 13 : 10}
                  style={errorCedulaE ? inputErrorStyle : inputStyle}
                  placeholder={tipDoc === 'P' ? 'Ingrese pasaporte' : 'Ingrese cédula'}
                />
                {errorMsg.cedulaE && <span style={errorMsgStyle}>{errorMsg.cedulaE}</span>}
              </div>

              {/* Birth date */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Fecha de Nacimiento (*)</span>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    format="yyyy/MM/dd"
                    value={selectedDate}
                    onChange={d => setSelectedDate(d)}
                    KeyboardButtonProps={{ 'aria-label': 'Cambiar fecha' }}
                    style={{ width: '100%' }}
                    inputVariant="outlined"
                    size="small"
                  />
                </MuiPickersUtilsProvider>
              </div>

              {/* Names */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Nombres y Apellidos (*)</span>
                <div style={rowStyle}>
                  <div>
                    <input style={errorMsg.nombresA ? inputErrorStyle : inputStyle} placeholder="Nombres" value={nombresA} 
                      onChange={e => { setNombresE(toMayusculas(e.target.value)); setErrorMsg(p => ({...p, nombresA: ''})); }} 
                      onBlur={() => blurField('nombresA', nombresA, 'Nombres')} />
                    {errorMsg.nombresA && <span style={errorMsgStyle}>{errorMsg.nombresA}</span>}
                  </div>
                  <div>
                    <input style={errorMsg.apellidosA ? inputErrorStyle : inputStyle} placeholder="Apellidos" value={apellidosA} 
                      onChange={e => { setApelE(toMayusculas(e.target.value)); setErrorMsg(p => ({...p, apellidosA: ''})); }} 
                      onBlur={() => blurField('apellidosA', apellidosA, 'Apellidos')} />
                    {errorMsg.apellidosA && <span style={errorMsgStyle}>{errorMsg.apellidosA}</span>}
                  </div>
                </div>
              </div>

              {/* Sex */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Sexo (*)</span>
                <select style={selectStyle} value={sex} onChange={e => setSex(e.target.value)}>
                  {sexo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>

              {/* Jornada */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Jornada (*)</span>
                <select style={selectStyle} value={jornada} onChange={e => setJornada(e.target.value)}>
                  {listJornada.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>

              {/* Grado */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Grado que aplica (*)</span>
                <select style={selectStyle} value={grado} onChange={e => setGrado(e.target.value)}>
                  {state.grados
                    ? state.grados.map(o => <option key={o.value} value={o.value}>{o.label}</option>)
                    : <option value="Default">Default</option>
                  }
                </select>
              </div>

              {/* Anteriormente en ANAI */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Estudió anteriormente en la ANAI (*)</span>
                <select style={selectStyle} value={estudio} onChange={e => setEstudio(e.target.value)}>
                  {listSiNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>

              {/* Institución */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Institución educativa de la que procede (*)</span>
                <input style={inputStyle} value={institucionAntes} onChange={e => setInstitucion(e.target.value)} placeholder="Nombre de la institución" />
              </div>

              {/* Personas */}
              <div style={sectionStyle}>
                <span style={labelStyle}>Personas con las que vive el estudiante (*)</span>
                <textarea
                  rows={4}
                  style={{ ...inputStyle, resize: 'vertical' }}
                  value={personasVive}
                  onChange={e => setPersonas(e.target.value)}
                  placeholder="Describa las personas con quién vive"
                />
              </div>

              {/* Hijo ex alumno */}
              <div style={sectionStyle}>
                <span style={labelStyle}>¿El aspirante es hijo de ex-alumnos? (*)</span>
                <select style={{ ...selectStyle, maxWidth: 200 }} value={hijoEx} onChange={e => setHijoEx(e.target.value)}>
                  {listSiNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>

              {/* Consentimiento */}
              <div style={{ ...sectionStyle, display: 'flex', alignItems: 'center', gap: 10 }}>
                <input
                  type="checkbox"
                  checked={state2.checkedA}
                  onChange={e => setState2({ checkedA: e.target.checked })}
                  style={{ width: 20, height: 20, accentColor: '#0d1b3e' }}
                />
                <div>
                  <span style={{ fontWeight: 600, color: '#333' }}>El estudiante debe tener calificación A o B en comportamiento</span>
                  <br />
                  <small style={{ color: '#999' }}>Condición importante para su admisión.</small>
                </div>
              </div>

              {/* Buttons */}
              <div style={btnRow}>
                <button className="btn-modern btn-modern-secondary" style={{ minWidth: 140 }} onClick={() => navigate("/menuMain")}>
                  🏠 Menú Inicio
                </button>
                <button className="btn-modern" style={{ minWidth: 140, background: '#e53935' }} onClick={() => {
                  Swal.fire({
                    title: '¿Salir?', text: 'Se perderán los datos no guardados.',
                    icon: 'warning', showCancelButton: true, confirmButtonColor: '#e53935',
                    cancelButtonColor: '#888', confirmButtonText: 'Sí, salir', cancelButtonText: 'Cancelar'
                  }).then(r => { if (r.isConfirmed) { dispatch({ type: "REMOVE_TOKEN" }); dispatch({ type: "RESET_CART_INS" }); navigate("/"); } });
                }}>
                  🚪 Salir
                </button>
                <button className="btn-modern btn-primary" style={{ minWidth: 150, fontWeight: 700 }} onClick={() => siguientePaso(0)}>
                  Siguiente ➡️
                </button>
              </div>
            </div>
          )}

          {/* ═══════ PASO 2 ═══════ */}
          {paso === 1 && (
            <div>
              <p style={{ color: '#555', marginBottom: 20, fontSize: '.9rem' }}>
                Ingresar los siguientes datos. Los campos con <b>(*)</b> son obligatorios.
              </p>

              {/* ── PADRE ── */}
              <h3 style={{ color: '#0d1b3e', borderBottom: '2px solid #d4a017', paddingBottom: 6, marginBottom: 16 }}>👨 Datos del Padre</h3>

              <div style={sectionStyle}>
                <span style={labelStyle}>Documento de identidad del padre (*)</span>
                <div style={pillContainerStyle}>
                  {[{ v: 'C', l: 'Cédula' }, { v: 'P', l: 'Pasaporte' }, { v: 'R', l: 'RUC' }].map(o => (
                    <span key={o.v} style={pillStyle(tipDocP === o.v)} onClick={() => setTipoDocP(o.v)}>{o.l}</span>
                  ))}
                </div>
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>{docLabel(tipDocP)} (*)</span>
                <input
                  ref={refCedulaP}
                  name="textmask"
                  value={cedulap.textmask}
                  onChange={(e) => { changeCedP(e); setErrorMsg(p => ({...p, cedulaP: ''})); setErrorCedulaP(false); }}
                  onBlur={blurCedulaP}
                  maxLength={tipDocP === 'R' ? 13 : tipDocP === 'P' ? 13 : 10}
                  style={errorCedulaP ? inputErrorStyle : inputStyle}
                  placeholder={docLabel(tipDocP)}
                />
                {errorMsg.cedulaP && <span style={errorMsgStyle}>{errorMsg.cedulaP}</span>}
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>Nombres del padre (*)</span>
                <div style={rowStyle}>
                  <div>
                    <input style={errorMsg.nombresP ? inputErrorStyle : inputStyle} placeholder="Nombres" value={nombresP} 
                      onChange={e => { setNombresP(toMayusculas(e.target.value)); setErrorMsg(p => ({...p, nombresP: ''})); }} 
                      onBlur={() => blurField('nombresP', nombresP, 'Nombres')} />
                    {errorMsg.nombresP && <span style={errorMsgStyle}>{errorMsg.nombresP}</span>}
                  </div>
                  <div>
                    <input style={errorMsg.apellidosP ? inputErrorStyle : inputStyle} placeholder="Apellidos" value={apellidosP} 
                      onChange={e => { setApellidosP(toMayusculas(e.target.value)); setErrorMsg(p => ({...p, apellidosP: ''})); }} 
                      onBlur={() => blurField('apellidosP', apellidosP, 'Apellidos')} />
                    {errorMsg.apellidosP && <span style={errorMsgStyle}>{errorMsg.apellidosP}</span>}
                  </div>
                </div>
              </div>

              {/* ── MADRE ── */}
              <h3 style={{ color: '#0d1b3e', borderBottom: '2px solid #d4a017', paddingBottom: 6, marginTop: 30, marginBottom: 16 }}>👩 Datos de la Madre</h3>

              <div style={sectionStyle}>
                <span style={labelStyle}>Documento de identidad de la madre (*)</span>
                <div style={pillContainerStyle}>
                  {[{ v: 'C', l: 'Cédula' }, { v: 'P', l: 'Pasaporte' }, { v: 'R', l: 'RUC' }].map(o => (
                    <span key={o.v} style={pillStyle(tipDocM === o.v)} onClick={() => setTipoDocM(o.v)}>{o.l}</span>
                  ))}
                </div>
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>{docLabel(tipDocM)} (*)</span>
                <input
                  ref={refCedulaM}
                  name="textmask"
                  value={cedulaM.textmask}
                  onChange={(e) => { changeCedM(e); setErrorMsg(p => ({...p, cedulaM: ''})); setErrorCedulaM(false); }}
                  onBlur={blurCedulaM}
                  maxLength={tipDocM === 'R' ? 13 : tipDocM === 'P' ? 13 : 10}
                  style={errorCedulaM ? inputErrorStyle : inputStyle}
                  placeholder={docLabel(tipDocM)}
                />
                {errorMsg.cedulaM && <span style={errorMsgStyle}>{errorMsg.cedulaM}</span>}
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>Nombres de la madre (*)</span>
                <div style={rowStyle}>
                  <div>
                    <input style={errorMsg.nombresM ? inputErrorStyle : inputStyle} placeholder="Nombres" value={nombresM} 
                      onChange={e => { setNombresM(toMayusculas(e.target.value)); setErrorMsg(p => ({...p, nombresM: ''})); }} 
                      onBlur={() => blurField('nombresM', nombresM, 'Nombres')} />
                    {errorMsg.nombresM && <span style={errorMsgStyle}>{errorMsg.nombresM}</span>}
                  </div>
                  <div>
                    <input style={errorMsg.apellidosM ? inputErrorStyle : inputStyle} placeholder="Apellidos" value={apellidosM} 
                      onChange={e => { setApellidosM(toMayusculas(e.target.value)); setErrorMsg(p => ({...p, apellidosM: ''})); }} 
                      onBlur={() => blurField('apellidosM', apellidosM, 'Apellidos')} />
                    {errorMsg.apellidosM && <span style={errorMsgStyle}>{errorMsg.apellidosM}</span>}
                  </div>
                </div>
              </div>

              {/* ── Contact ── */}
              <h3 style={{ color: '#0d1b3e', borderBottom: '2px solid #d4a017', paddingBottom: 6, marginTop: 30, marginBottom: 16 }}>📧 Contacto</h3>

              <div style={sectionStyle}>
                <span style={labelStyle}>Correo electrónico del padre (*)</span>
                <input style={errorMsg.mail ? inputErrorStyle : inputStyle} type="email" value={mail} 
                  onChange={e => { setMail(e.target.value); setErrorMsg(p => ({...p, mail: ''})); }} 
                  onBlur={() => blurEmail('mail', mail)}
                  placeholder="correo@ejemplo.com" />
                {errorMsg.mail && <span style={errorMsgStyle}>{errorMsg.mail}</span>}
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>Correo electrónico de la madre (*)</span>
                <input style={errorMsg.mailM ? inputErrorStyle : inputStyle} type="email" value={mailM} 
                  onChange={e => { setMail2(e.target.value); setErrorMsg(p => ({...p, mailM: ''})); }} 
                  onBlur={() => blurEmail('mailM', mailM)}
                  placeholder="correo@ejemplo.com" />
                {errorMsg.mailM && <span style={errorMsgStyle}>{errorMsg.mailM}</span>}
              </div>

              <div style={sectionStyle}>
                <div style={rowStyle}>
                  <div>
                    <span style={labelStyle}>Número celular (*)</span>
                    <input style={errorMsg.celular ? inputErrorStyle : inputStyle} type="tel" maxLength={10} value={celular} 
                      onChange={e => { setCelular(soloNumeros(e.target.value)); setErrorMsg(p => ({...p, celular: ''})); }} 
                      onBlur={() => blurPhone('celular', celular, 'Celular')}
                      placeholder="09XXXXXXXX" />
                    {errorMsg.celular && <span style={errorMsgStyle}>{errorMsg.celular}</span>}
                  </div>
                  <div>
                    <span style={labelStyle}>Teléfono convencional (*)</span>
                    <input style={errorMsg.convencional ? inputErrorStyle : inputStyle} type="tel" maxLength={10} value={convencional} 
                      onChange={e => { setConvencional(soloNumeros(e.target.value)); setErrorMsg(p => ({...p, convencional: ''})); }} 
                      onBlur={() => blurPhone('convencional', convencional, 'Teléfono')}
                      placeholder="04XXXXXXX" />
                    {errorMsg.convencional && <span style={errorMsgStyle}>{errorMsg.convencional}</span>}
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div style={btnRow}>
                <button className="btn-modern btn-modern-secondary" style={{ minWidth: 140 }} onClick={() => setSteps(0)}>
                  ⬅️ Anterior
                </button>
                <button className="btn-modern btn-primary" style={{ minWidth: 150, fontWeight: 700 }} onClick={() => siguientePaso(1)}>
                  Siguiente ➡️
                </button>
              </div>
            </div>
          )}

          {/* ═══════ PASO 3 ═══════ */}
          {paso === 2 && (
            <div>
              <p style={{ color: '#555', marginBottom: 20, fontSize: '.9rem' }}>
                Ingrese la información de la persona que realizará el pago para la inscripción.
              </p>

              <div style={sectionStyle}>
                <span style={labelStyle}>Documento de identidad (*)</span>
                <div style={pillContainerStyle}>
                  {[{ v: 'CI', l: 'Cédula' }, { v: 'PPN', l: 'Pasaporte' }, { v: 'RUC', l: 'RUC' }].map(o => (
                    <span key={o.v} style={pillStyle(tipoDocPag === o.v)} onClick={() => setValueTip(o.v)}>{o.l}</span>
                  ))}
                </div>
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>{docLabel(tipoDocPag)} (*)</span>
                <input
                  ref={refCedulaPa}
                  name="textmask"
                  value={cedulaPa.textmask}
                  onChange={(e) => { changeCedPa(e); setErrorMsg(p => ({...p, cedulaPa: ''})); setErrorCedulaPa(false); }}
                  onBlur={blurCedulaPa}
                  maxLength={tipoDocPag === 'RUC' ? 13 : tipoDocPag === 'PPN' ? 13 : 10}
                  style={errorCedulaPa ? inputErrorStyle : inputStyle}
                  placeholder={docLabel(tipoDocPag)}
                />
                {errorMsg.cedulaPa && <span style={errorMsgStyle}>{errorMsg.cedulaPa}</span>}
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>Nombres (*)</span>
                <div style={rowStyle}>
                  <div>
                    <input style={errorMsg.nombresPa ? inputErrorStyle : inputStyle} placeholder="Nombres" value={nombresPa} 
                      onChange={e => { setNombresPa(toMayusculas(e.target.value)); setErrorMsg(p => ({...p, nombresPa: ''})); }} 
                      onBlur={() => blurField('nombresPa', nombresPa, 'Nombres')} />
                    {errorMsg.nombresPa && <span style={errorMsgStyle}>{errorMsg.nombresPa}</span>}
                  </div>
                  <div>
                    <input style={errorMsg.apellidosPa ? inputErrorStyle : inputStyle} placeholder="Apellidos" value={apellidosPa} 
                      onChange={e => { setApelPa(toMayusculas(e.target.value)); setErrorMsg(p => ({...p, apellidosPa: ''})); }} 
                      onBlur={() => blurField('apellidosPa', apellidosPa, 'Apellidos')} />
                    {errorMsg.apellidosPa && <span style={errorMsgStyle}>{errorMsg.apellidosPa}</span>}
                  </div>
                </div>
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>Correo electrónico (*)</span>
                <input style={errorMsg.mailPa ? inputErrorStyle : inputStyle} type="email" value={mailPa} 
                  onChange={e => { setMailPa(e.target.value); setErrorMsg(p => ({...p, mailPa: ''})); }} 
                  onBlur={() => blurEmail('mailPa', mailPa)}
                  placeholder="correo@ejemplo.com" />
                {errorMsg.mailPa && <span style={errorMsgStyle}>{errorMsg.mailPa}</span>}
              </div>

              <div style={sectionStyle}>
                <span style={labelStyle}>Dirección (*)</span>
                <input style={errorMsg.direccionPa ? inputErrorStyle : inputStyle} value={direccionPa} 
                  onChange={e => { setDireccionPa(e.target.value); setErrorMsg(p => ({...p, direccionPa: ''})); }} 
                  onBlur={() => blurField('direccionPa', direccionPa, 'Dirección')}
                  placeholder="Dirección completa" />
                {errorMsg.direccionPa && <span style={errorMsgStyle}>{errorMsg.direccionPa}</span>}
              </div>

              {/* Tasa */}
              <div style={{
                display: 'flex', alignItems: 'center', gap: 14, background: 'linear-gradient(135deg,#e8eaf6,#f5f5f5)',
                padding: '14px 20px', borderRadius: 10, marginTop: 10, marginBottom: 10
              }}>
                <span style={{ fontWeight: 700, color: '#666' }}>Tasa de inscripción:</span>
                <span style={{ fontWeight: 800, fontSize: '1.2rem', color: '#0d1b3e' }}>
                  ${state.opciones ? state.opciones.tasaInscripcion : "0"}
                </span>
              </div>

              <p style={{ color: '#888', fontSize: '.85rem', marginBottom: 10 }}>
                Revise la información ingresada antes de añadir al carrito. Una vez añadido, se redirigirá al botón de pago.
              </p>

              {/* Buttons */}
              <div style={btnRow}>
                <button className="btn-modern btn-modern-secondary" style={{ minWidth: 140 }} onClick={() => setSteps(1)}>
                  ⬅️ Anterior
                </button>
                <button className="btn-modern btn-save" style={{ minWidth: 180 }} onClick={validarData}>
                  🛒 Agregar al carrito
                </button>
              </div>
            </div>
          )}

        </div>{/* end card */}

        <div className="modern-copyright" style={{ marginTop: 20 }}>
          © {new Date().getFullYear()} Academia Naval Almirante Illingworth
          <br />
          <span style={{ fontSize: '0.75rem', color: '#999', marginTop: 4, display: 'inline-block' }}>Diseñado y Desarrollado por Departamento de Sistemas ANAI</span>
        </div>
      </div>
    </div>
  );
}
